export default function settingsReducer(state = {}) {
  return state;
}
